<template>
    <div class="container" v-if="isVisible">
        <!-- Modal content -->
        <div class="modal" ref="popup"></div>
        <div class="window">
            <div class="close-page text-center" @click="cancel">
                <font-awesome-icon icon="fa-close" class="close-icon" />
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="col-md-12 text-center">
                        <h4>Benutzereinstellungen ändern</h4>
                        <h5>Benutzer: {{ userName }}</h5>
                    </div>
                    <div class="col-md-12 input-field">
                        <label for="newPassword">Neues Passwort</label>
                        <input :type="passwordVisible ? 'text' : 'password'" name="newPassword"
                            v-model="newPassword" autocomplete="new-password" />
                        <div class="password-actions">
                            <button type="button" class="btn btn-outline-light btn-sm"
                                @click="generateUserPassword">
                                Generieren
                            </button>
                            <button type="button" class="btn btn-outline-light btn-sm"
                                @click="copyUserPassword" :disabled="!newPassword">
                                Kopieren
                            </button>
                        </div>
                        <span class="copy-feedback" v-if="copyFeedback">{{ copyFeedback }}</span>
                    </div>
                    <div class="col-md-12 input-field">
                        <label for="newPasswordConf">Passwort bestätigen</label>
                        <input :type="passwordVisible ? 'text' : 'password'" for="newPasswordConfirm"
                            v-model="newPasswordConfirmed" ref="newPasswordConfirmInput" autocomplete="new-password"
                            @blur="passwordMatch" />
                        <span style="color: red" v-if="passwordWrongDisplay">Passwörter sicht nicht gleich!</span>
                    </div>
                    <div class="col-md-12 input-field">
                        <label for="role">Benutzerrolle ändern</label>
                        <select name="role" class="form-control" v-model="userRole">
                            <option value="administrator">Administrator</option>
                            <option value="user">Nutzer</option>
                        </select>
                    </div>
                    <div class="col-md-12 text-center">
                        <button class="btn btn-success" @click="confirm" :disabled="passwordWrongDisplay">
                            Ändern
                        </button>
                        <button class="btn btn-warning" @click="cancel">
                            Schliessen
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { copyTextToClipboard, generatePassword } from '@/utils/generatePassword';

export default {

    data() {
        return {
            isVisible: false,
            newPassword: '',
            newPasswordConfirmed: '',
            passwordWrongDisplay: false,
            passwordVisible: false,
            copyFeedback: '',
            userRole: '',
            userName: '',
        };
    },
    methods: {
        show(opts = {}) {
            console.log(opts);
            this.isVisible = true;
            this.userName = opts.userName;
            this.userRole = opts.userRole;
            this.newPassword = '';
            this.newPasswordConfirmed = '';
            this.passwordWrongDisplay = false;
            this.passwordVisible = false;
            this.copyFeedback = '';
        },
        hide() {
            this.isVisible = false;
        },
        cancel() {
            this.hide();
        },
        async generateUserPassword() {
            const password = generatePassword(10);
            this.newPassword = password;
            this.newPasswordConfirmed = password;
            this.passwordVisible = true;
            this.passwordWrongDisplay = false;
            try {
                const ok = await copyTextToClipboard(password);
                this.copyFeedback = ok
                    ? 'Generiert und kopiert'
                    : 'Generiert — bitte „Kopieren“ nutzen';
            } catch (err) {
                this.copyFeedback = 'Generiert — bitte „Kopieren“ nutzen';
                console.log(err);
            }
        },
        async copyUserPassword() {
            try {
                const ok = await copyTextToClipboard(this.newPassword);
                this.copyFeedback = ok ? 'Kopiert!' : 'Bitte manuell markieren';
            } catch (err) {
                this.copyFeedback = 'Bitte manuell markieren';
                console.log(err);
            }
        },
        confirm() {
            if (this.newPasswordConfirmed === this.newPassword) {
                this.$emit(
                    'confirm',
                    this.newPasswordConfirmed,
                    this.userRole,
                );
                this.newPasswordConfirmed = '';
                this.newPassword = '';
                this.userRole = '';
                this.passwordVisible = false;
                this.copyFeedback = '';
                this.hide();
            } else {
                this.passwordWrongDisplay = true;
            }
        },
        passwordMatch() {
            if (this.newPasswordConfirmed === this.newPassword) {
                this.passwordWrongDisplay = false;
            } else {
                this.passwordWrongDisplay = true;
            }
        },
    },
};
</script>

<style scoped>
.modal {
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    z-index: 1;
    overflow-y: hidden;
    height: 100vh;
    width:100vw;
}

.window {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #264271;
    z-index: 1;
    width: 360px;
    min-height: 600px;
    height: auto;
    padding-bottom: 1.5rem;
    color: white;
    border-radius: 25px;
    border: 2px solid lightblue;
}

h4 {
    margin-top: 3rem;
}

.input-field {
    display: flex;
    flex-direction: column;
    margin: 2rem 3rem;
}

.input-field input {
    width: 75%;
    border: none;
    border-bottom: 1px solid lightblue;
    background-color: transparent;
    height: 2rem;
    color: white;
}

.input-field select {
    width: 75%;
}

.input-field label {
    font-size: 1.3rem;
}

.input-field input:focus {
    background-color: #446bae;
    border-radius: 5px;
    outline: none;
}

.password-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 0.75rem;
}

.copy-feedback {
    margin-top: 0.4rem;
    font-size: 0.9rem;
    color: #b8f0c8;
}

.close-page {
    position: absolute;
    width: 25px;
    height: 25px;
    transform: translateX(25%);
    top: 1rem;
    right: 1.5rem;
    cursor: pointer;
}
.btn-warning{
    margin-left:1rem;
}

@media (max-width: 768px) {
    .window {        
        top:0%;
        transform: translateX(-50%);
        margin-top: 59rem;
    }

    .input-field input, .input-field select{
        width: 100%;
    }
}
</style>
